
export default {
  name: 'AlertLayout'
}
